import { LosseLink, useLoaderData } from '@ubo/losse-sjedel'
import Animated from '~/components/elements/Animated'
import Content from '~/components/elements/Content'
import type { Page_Flexcontent_Flex_Hubspot } from '~/graphql/types'
import { type ProfilePageLoaderData } from '~/services/hubspot.server'

export default function HubspotCompany({ fields, index }: { fields: Page_Flexcontent_Flex_Hubspot; index: number }) {
  const { hubspotData: profile } = useLoaderData<ProfilePageLoaderData>()

  return (
    <section data-component="HubspotCompany" className="section">
      <div className="container">
        <div className="max-w-screen-md mx-auto">
          <div className="flex flex-col gap-y-6">
            {fields.title && (
              <Animated delay={100}>
                <h2 className="title--normal">{fields.title?.replace('{company_name}', profile.properties.carerix_job_company_name)}</h2>
              </Animated>
            )}
            {fields.subtext && (
              <Animated delay={200}>
                <div>
                  <Content
                    data-id={`content-${index}`}
                    className="content children-strong:text-site-base children-strong:children-li:text-site-conversion list--stripe--accent"
                  >
                    {fields?.subtext.replace('{company_intro}', profile.properties.carerix_job_company_intro)}
                  </Content>
                </div>
              </Animated>
            )}
            <Animated delay={200}>
              <div>
                <LosseLink className="btn--conversion" target="_blank" to={profile.deals[0].company.website}>
                  Bekijk website
                </LosseLink>
              </div>
            </Animated>
          </div>
        </div>
      </div>
    </section>
  )
}
